// Copyright (c) Facebook, Inc. and its affiliates.
import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Container from '@material-ui/core/Container';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography'
import { MuiThemeProvider } from '@material-ui/core/styles';
import { BrowserRouter as Router, Route } from "react-router-dom";

import Explore from './components/Explore';

import './App.css';

class App extends Component {
  render() {
    return (
      <MuiThemeProvider>
        <Container fixed maxWidth="lg" position="static" color="default">
          <Typography  color="inherit" style={{fontSize:24, fontWeight:400}}>
          Validation Set Examples
          </Typography>
      </Container>
        <div className="App">
            <Explore/>
          </div>
      </MuiThemeProvider>
    );
  }
}

export default App;
